module.exports = __webpack_public_path__ + "img/图层 16.7dc6417f.png";